import { render, staticRenderFns } from "./wendang_edit.vue?vue&type=template&id=771a1e3f&scoped=true&"
import script from "./wendang_edit.vue?vue&type=script&lang=js&"
export * from "./wendang_edit.vue?vue&type=script&lang=js&"
import style0 from "./wendang_edit.vue?vue&type=style&index=0&id=771a1e3f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a1e3f",
  null
  
)

export default component.exports